import {
  AppBar,
  Stack,
  Typography,
  useTheme,
  useMediaQuery,
  styled,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import { styled } from '@mui/styles';
import React from 'react';

export const StyledAppBar = styled(AppBar)(() => ({
  backgroundColor: '#FFF',
}));

export const BackButton = ({ backFn, backMsg }) => {
  const theme = useTheme();
  return (
    <Stack
      direction={'row'}
      alignItems={'center'}
      gap={'10px'}
      sx={{ cursor: 'pointer' }}
      onClick={() => backFn()}
    >
      <ArrowBackIcon htmlColor={theme.palette.grey[900]} />
      <Typography
        variant="link1"
        sx={{ textDecoration: 'underline' }}
        color={theme.palette.grey[900]}
      >
        {backMsg}
      </Typography>
    </Stack>
  );
};

export const RedLinkButton = ({
  onClick,
  msg,
  marginRight = null,
  leftIcon = null,
  rightIcon = null,
  hideTextOnMobile = false,
  customStyle = {},
  variant = 'link2',
  disabled = false,
}) => {
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Stack
      direction={'row'}
      justifyContent={'space-between'}
      alignItems={'center'}
      gap={'10px'}
      sx={{ cursor: disabled ? 'default' : 'pointer', ...customStyle }}
      marginRight={marginRight}
      onClick={onClick}
    >
      {leftIcon}
      {hideTextOnMobile && isSmDown ? null : (
        <Typography
          variant={variant}
          sx={{
            textDecoration: 'underline',
            ...(disabled && {
              color: '#E2001A',
              // color: '#EC0E00',
              opacity: 0.2,
            }),
          }}
          fontWeight={600}
          color="primary"
        >
          {msg}
        </Typography>
      )}
      {rightIcon}
    </Stack>
  );
};

export const Overlay = styled('div')({
  position: 'absolute',
  bottom: '0',
  top: 0,
  background: 'rgba(0, 0, 0, 0.5)',
  width: '100%',
  color: '#f1f1f1',
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
});

export const ImageContainer = styled('div')({
  position: 'relative',
  width: '100%',
});

export const Image = styled('img')({
  display: 'block',
  width: '100%',
  height: 'auto',
  maxHeight: 580,
  objectFit: 'cover',
});

export const TextButton = ({ text, variant }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minWidth: '192px',
      height: '46px',
    }}
  >
    <Typography variant={variant} color={'#FFF'}>
      {text}
    </Typography>
  </div>
);
